'use client';

import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FC } from 'react';
import Logo from '~/data/strapi/types/single-types/common-data/logo';
import alt from '~/utils/default-alt';
import getDataPath from '~/utils/get-data-path';

import styles from './styles.module.css';

interface Props {
  logo: Logo;
}

const HeaderLogo: FC<Props> = ({ logo }) => {
  const path = usePathname();
  const { image, title } = logo;

  if (!image || !image.alternativeText || !title) return null;

  const alternativeText = image.alternativeText;

  return (
    <div className={styles.imageContainer} title={title}>
      {path === '/' ? (
        <Image fetchPriority="high" src={getDataPath(image.url)} alt={alt(alternativeText)} priority={true} fill />
      ) : (
        <Link href="/" className={styles.homeLink}>
          <Image
            src={getDataPath(image.url)}
            alt={alt(alternativeText)}
            fetchPriority="high"
            aria-label="Перейти на главную страницу"
            priority={true}
            fill
          />
        </Link>
      )}
    </div>
  );
};

export default HeaderLogo;
